import { sortArrayByArray } from '@sales-center/common'
import { State, SelectPayload, SortPayload, TogglePayload } from './typings'

export function toggleItem(state: State, payload: TogglePayload): State {
  const { field, value } = payload

  const { columns, sortedColumns } = state

  const index = columns.findIndex((x) => x.field === field)

  if (index !== -1 && !columns[index].disabled) {
    columns[index].checked = value

    const sortedIndex = sortedColumns.findIndex((x) => x.field === field)
    if (sortedIndex === -1 && value) {
      sortedColumns.push(columns[index])
    } else if (sortedIndex !== -1 && !value) {
      sortedColumns.splice(sortedIndex, 1)
    }
  }

  return { ...state, columns, sortedColumns }
}

export function selectItems(state: State, payload: SelectPayload): State {
  switch (payload) {
    case 'all':
      const unchecked = state.columns.filter((c) => !c.checked)

      return {
        ...state,
        columns: state.columns.map((c) => ({ ...c, checked: true })),
        sortedColumns: [...state.sortedColumns, ...unchecked],
      }

    case 'none':
      return {
        ...state,
        columns: state.columns.map((c) => ({ ...c, checked: c.disabled })),
        sortedColumns: state.sortedColumns.filter((c) => c.disabled),
      }
  }
}

export function sortItems(state: State, payload: SortPayload): State {
  const { sortedColumns } = state

  const src = sortedColumns.splice(payload.sourceIndex, 1).pop()
  if (src) {
    sortedColumns.splice(payload.destinationIndex, 0, src)
  }

  return { ...state, sortedColumns }
}

export function resetDefault(state: State): State {
  const { columns, defaultColumns, defaultVisibility } = state

  if (defaultColumns.length === 0) return selectItems(state, 'all')

  const updatedColumns = columns.map((c) => ({
    ...c,
    checked: c.disabled || defaultVisibility[c.field],
  }))

  const sortedColumns = sortArrayByArray(
    updatedColumns.filter((c) => c.checked),
    defaultColumns,
    (c) => c.field,
  )

  return { ...state, columns: updatedColumns, sortedColumns }
}
